import useCallApi from '../../utilities/axios'

export type ClosedKeywordType = {
    keyword?: string
    projectType?: number | null
    startDate: string | Date
    endDate: string | Date
    userID: number | null
}

export type ClosedDataListType = {
    projectID: number
    projectNumber: string
    closedDate: string
    receiveDate: string
    projectName: Translation
    projectType: {
        id: number
        name: Translation
    }
    name: Translation
    title: Translation
    academicPosition: Translation
    isPhD: boolean
    researcherTypeName: Translation
}

type Translation = {
    th: string
    en: string
}

export const useSearchClosed = () => {
    const callApi = useCallApi()

    const searchClosed = async (values: ClosedKeywordType) => {
        const { data } = await callApi.axiosPost({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/dashboard/search/project/closed`,
            params: { ...values },
        })

        return data
    }

    return {
        searchClosed,
    }
}
